import React from "react";
import { Link } from "react-router-dom";

// Shared shell for Privacy Policy / Terms / FAQ — plain, readable, printable.
// Not styled like the rest of the playful Kids Zone on purpose: these are
// documents people scan or print, not screens kids interact with.
export default function LegalPage({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-ground font-body">
      <header className="border-b border-panel-line bg-white">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/kids" className="font-display font-semibold text-lg">
            <span className="text-brand">Cabil</span> <span className="text-gold">Kids</span>
          </Link>
          <Link to="/kids" className="text-sm font-body font-semibold text-muted hover:text-brand transition">
            ← Back to Cabil Kids
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="font-display font-semibold text-3xl text-ink mb-1">{title}</h1>
        {updated && <p className="text-sm text-muted mb-8">Last updated {updated}</p>}
        <div className="prose-legal text-ink text-[15px] leading-relaxed space-y-6">
          {children}
        </div>
      </main>

      <style>{`
        .prose-legal h2 { font-family:'Fredoka',sans-serif; font-weight:600; font-size:19px; color:#232A36; margin-top:8px; }
        .prose-legal p, .prose-legal li { color:#3A4150; }
        .prose-legal ul { list-style: disc; padding-inline-start: 1.4rem; }
        .prose-legal a { color:#EE5F2B; font-weight:700; }
      `}</style>
    </div>
  );
}
